export default __webpack_public_path__ + "static/media/Substrates-Marketplace.75c828f2.svg";